import React from 'react'
import { ScrollView, Text, useWindowDimensions, View } from 'react-native'
import HeaderWithBack from '../../components/Header/headerWithBack'
import { useCssStyle } from '../../customHook/getCssStyle';
import CustomFlatList from '../../components/customFlatList';
import CustomPressable from '../../components/customPressable/customPressable';
import { ImageComp } from '../../components/Image/Image';
import { CHEVRON_RIGHT } from '../../assets';
import RenderHTML from 'react-native-render-html';
import { useSelector } from 'react-redux';
import { getCleanUrl } from '../../utils/Helper';
import { useTranslation } from 'react-i18next';
import { getStyleForRenderHTML } from '../../js/utility';

const ReservationEventList = (props) => {
    const { availableEvents, handleNext, handleGoBack} = props;

    const getStyles = useCssStyle();
    const { width } = useWindowDimensions();
    const { t } = useTranslation();

    const { currentWidget } = useSelector(state => state.deviceConfigSlice);

    console.log("availableEvents", availableEvents)

    const renderHeader = () => {
        return <View style={getStyles(['widgetmainContainerHeaderContainer', 'reservationsHeaderContainer'])}>
            {
                currentWidget?.widgetHeaderImageUrl &&
                <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'reservationsHeaderImg'])} />
            }
            <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'reservationsHeaderTitleContainer'])}>
                <Text style={getStyles(['widgetmainContainerHeaderTitle', 'reservationsHeaderTitle'])}>{t('events.heading1')}</Text>
            </View>
        </View>
    }

    const renderItem = ({item}) => {
        let eventName = item.eventName;
        let eventId = item.eventId;
        let eventDesc = item.events[0].description;

        const customGuestRequestTitleStyle = getStyles([
            'list_itemContainer_textContainer_subtitle',
            'reservations_itemContainer_textContainer_subtitle'
        ]);

        const { baseStyle: titleBaseStyle, systemFonts: titleSystemFonts } = getStyleForRenderHTML(customGuestRequestTitleStyle);
        return (
            <CustomPressable 
                id={`list_itemContainer reservationsItemContainer`} 
                style={getStyles(['list_itemContainer', 'reservationsItemContainer'])} 
                onPress={() => handleNext(item)}
            >
                <View id='list_itemContainer_textContainer reservations_itemContainer_textContainer' style={getStyles(['list_itemContainer_textContainer', 'reservations_itemContainer_textContainer'])}>
                    
                    {eventName && 
                        <Text 
                            id='list_itemContainer_textContainer_title reservations_itemContainer_textContainer_title' 
                            style={getStyles(['list_itemContainer_textContainer_title', 'reservations_itemContainer_textContainer_title'])}
                        >
                            {eventName}
                        </Text>}
                    {eventDesc && 
                        <RenderHTML 
                            contentWidth={width}
                            baseStyle={titleBaseStyle}
                            source={{html: eventDesc}}
                            systemFonts={titleSystemFonts}
                            numberOfLines={2}
                            id={`list_itemContainer_textContainer_subtitle reservations_itemContainer_textContainer_subtitle`}
                        />
                    }
                </View>

                <View id='list_itemContainer_arrow reservations_itemContainer_arrow' style={getStyles(['list_itemContainer_arrow', 'reservations_itemContainer_arrow'])}>
                    <ImageComp source={CHEVRON_RIGHT} style={getStyles(['list_itemContainer_arrow_img'])} />
                </View>

            </CustomPressable>
        );
    }
    return (
        <View style={getStyles(['widgetRootContainer', 'reservationsRootContainer'])}>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />
            
            <ScrollView automaticallyAdjustKeyboardInsets={true} contentContainerStyle={getStyles(['widgetmainContainer', 'reservationsMainContainer'])} showsVerticalScrollIndicator={false}>
                {renderHeader()}

                <View style={getStyles(['widgetmainContainerChildContainer', 'reservationsMainContainerChildContainer'])}>
                    <CustomFlatList
                        data={availableEvents}
                        renderItem={renderItem}
                        contentContainerStyle={getStyles(['reservationsMainWidgetsContainer'])}
                        keyExtractor={item => item?.widgetId}
                        id={`reservationsMainWidgetsContainer`}
                    />
                </View>
            </ScrollView>
        </View>
    )
}

export default ReservationEventList
